import React from 'react';
import "./styles.css"

const OrderSummary = ({ show,setShowOrderSummary,data,setShowMobileMoneyModal, paymentType }) => {
    if (!show) {
        return null;
    }

    const handleCloseOrderSummary = () => {
        setShowOrderSummary(false)
    }

    const handleMakePayment = (e) => {
        if (paymentType === 'Mobile Money') {
            setShowOrderSummary(false)
            setShowMobileMoneyModal(true);
        }else{
            window.location.href = data.payment_link
        }
    }


    return (
        <div className="order_total_summary">
            <div className="order_table_container">
                <h3>Registration Confirmation</h3>

                <div className='atlanticOrder_P'>
                    <h2>Atlantic Meal Registration</h2>
                    <h5>Kindly review before proceeding to payment</h5>
                </div>

                <table cellSpacing="0" cellPadding="0">
                    <thead>
                        <tr>
                            <th>Student Name</th>
                            <th>Term</th>
                            <th>Amount</th>
                            <th>Charges</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td data-label="Student">{data.studentName}</td>
                            <td data-label="Term">{data.selectedTerm}</td>
                            <td data-label="Amount">&#8373;{data.termAmount}</td>
                            <td data-label="Charges">&#8373;{data.bankCharges}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td data-label="Net Amount" colSpan="4" style={{ textAlign: 'center', fontWeight: 'bolder' }}>
                                Total: &#8373;{data.totalAmount}
                            </td>
                        </tr>
                    </tfoot>
                </table>

                <div className="order_summary-btn-container">
                    <button type='button' onClick={handleMakePayment} className="processToPayment_btn">Make Payment</button>
                    <button type='button' onClick={handleCloseOrderSummary} className='cancelPayment_btn'>Cancel Order</button>
                </div>

            </div>
        </div>
    );
};

export default OrderSummary;
